/**
 * Contains Common Functions used throughout the application
*/
import Constants from "../constants/index";
import i18n from '../i18n';
import { store } from '../store/store'

export default {


    /**
     * Generates ID based on current time and date
     * 
     * @returns 
     */
    randomId() {
        return Date.now().toString(36) + Math.random().toString(36).substring(2);
    },

    /**
     * Generates the Base 64 String from a File
     * 
     *  Usage 
     *  getBase64FromFile(file).then(
     *    data => {
     *       data is the encoded file
     *    }  
     *   );
     * @param file - File URL
     * @returns promise
    */
    getBase64FromFile(file) {

        return new Promise((resolve, reject) => {

            if (file) {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => resolve(reader.result);
                reader.onerror = error => reject(error);
            }
        });

    },

    /**
     * Converts a String to an Uppercase String
     * 
     * @param string - The String
     * @returns The Converted String
    */
    toUpperCase(string) {
        return string.toUpperCase();
    },

    /**
     * Seperates a number into thousands
     * Eg: 100000 => 100,000
     * @param digit - the number you want to convert
     * @param seperator - the string seperator
     * @returns The converted String
    */
    thousandSeparator(digit = 0, separator = ',') {

        return digit.toString().replace(/\B(?=(\d{3})+(?!\d))/g, separator);
    },

    /**
     * Gets the Display String by the noun
     * 
     * @param noun - the string 
     * @returns Display String
    */
    getIntervalByNoun(noun) {
        const valuePairs = { month: "Monthly", year: "Annually", quarter: 'Quarterly' };
        return valuePairs[noun];
    },

    /**
    * Sets the given Key and Data in the Local Storage
    * 
    * @param key - The Local Storage Key
    * @param data - The Value
    * @param isJson - true, if we want to JSON Encode the data
    * 
    * @return void
    */
    setinLocalStorage(key, data, isJson = true) {

        localStorage.setItem(key, (isJson == true) ? JSON.stringify(data) : data);

    },
    /**
    * Gets the Data from Local Storage by the Key Specified
    * 
    * @param key - The Key stored in the Local Storage
    * @param isJson - true, if we want to JSON Decode the data
    * 
    * @return the value from the Local Storage
    */
    getFromLocalStorage(key, isJson = true) {

        const result = (isJson == true) ? JSON.parse(localStorage.getItem(key)) : localStorage.getItem(key);
        return (result) ? result : null;

    },

    /**
     * Deletes a Key and Value from the Local Storage
     * @param key - The key which is stored in the Local Storage
     * 
     * @return void
     */
    deleteFromLocalStorage(key) {

        localStorage.removeItem(key);

    },

    /**
     * Converts a UNIX time to a human readable time
     * @param UNIX_timestamp
     * 
     * @return readable time
     */
    unixToReadableTime(UNIX_timestamp) {
        var a = new Date(UNIX_timestamp * 1000);
        var months = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
        var year = a.getFullYear();
        var month = months[a.getMonth()];
        var date = a.getDate();
        // var hour = a.getHours();
        // var min = a.getMinutes();
        // var sec = a.getSeconds();
        var time = date + '.' + month + '.' + year; //+ ' ' + hour + ':' + min ; //+ ':' + sec ;
        return time;
    },


    /**
    * Created By : Nilaksha
    * Created At : 19/1/2022
    * Summary : Check if an auth user possess any role
    * 
    * @param {*} roleid 
    * @returns 
    */
    isAuthUser(roleid) {

        const authUser = this.getFromLocalStorage(Constants.auth_user, true);
        if (authUser) {
            const roleAssignments = authUser['role_assignments_instance'];

            for (let i = 0; i < roleAssignments.length; i++) {
                if (roleAssignments[i]['roleid'] == roleid) {
                    return true;
                }
            }
        }


        return false;
    },

    /**
     * Returns whether the route is an authorized route for the logged-in user
     * @param routeName - Route name can be found in routes defined in the router/index.js file. Routes that are being checked by this method has the route name.
     * 
     * @return true, if authoried, else: false
     */
    isAuthorized(routeName) {

        const routeData = store.getters.routeData;
        const authUser = this.getFromLocalStorage(Constants.auth_user, true);

        if (authUser && routeData[routeName]) {
            const roleAssignments = authUser['role_assignments_instance'].map(assignment => assignment.roleid);
            const { authorizedUserRoles } = routeData[routeName];

            return authorizedUserRoles.some(role => roleAssignments.includes(role));
        }

        return false;
    },

    // dynamicSort(property) {
    //     var sortOrder = 1;
    //     if(property[0] === "-") {
    //         sortOrder = -1;
    //         property = property.substr(1);
    //     }
    //     return function (a,b) {
    //         /* next line works with strings and numbers, 
    //          * and you may want to customize it to your needs
    //          */
    //         var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
    //         return result * sortOrder;
    //     }
    // },

    /**
     * Sends a HTTP GET request to a URL
     * @param theUrl - URL that you need to request
     * 
     * @return HTTP Response
     */
    httpGet(theUrl) {
        var xmlHttp = new XMLHttpRequest();
        xmlHttp.open("GET", theUrl, false); // false for synchronous request
        xmlHttp.send(null);
        return xmlHttp.responseText;
    },

    /**
     * Get an image path by the image name and context
     * @param imageName
     * 
     * @return the image path
     */
    getImagefromContext(imageName) {

        const images = require.context('../assets/imgs/', false, /\.png$/)
        return images("./" + imageName + ".png");

    },

    /**
     * Handles whether the request method is not allowed and errors are defined
     * @param error - HTTP Error Response
     * 
     * @return error
     */
    handleRequestValidators(error) {

        if (error.response.status == 422 && error.response.data.errors != undefined) {
            error.response.data['success'] = false;
            return error.response.data;
        }

        throw error;

    },

    /**
     * Converts minutes into a human readable string with Hours and minutes
     * 
     * @param n - Number of minutes
     * @returns human readable string
     */
    timeConvert(n) {
        var num = n;
        var days = (num / (60*24));
        var rdays = Math.floor(days);
        var hours = (days - rdays) * 24;
        var rhours = Math.floor(hours);
        var minutes = (hours - rhours) * 60;
        var rminutes = Math.round(minutes);
        return ((rdays > 0) ? rdays + " " + ((rdays > 1) ? i18n.t(Constants.days_text) + ' ' : i18n.t(Constants.day_text)) + ' ' : '') +
            ((rhours > 0) ? rhours + " " + ((rhours > 1) ? i18n.t(Constants.hours_text) + ' ' : i18n.t(Constants.hour_text)) + ' ' : '') +
            ((rhours > 0 && rminutes > 0) ? ' ' + i18n.t(Constants.and_text) + ' ' : '') +
            ((rminutes > 0) ? rminutes + " " + ((rminutes > 1) ? i18n.t(Constants.minutes_text) : i18n.t(Constants.minute_text)) + "." : '');
    },
    /**
     * Transforms a number to a thousand seperated string with currency attached
     * 
     * @param num 
     * @param currency 
     * @returns string
     */
    formatMoney(num, currency) {

        if (!num) {
            return '00.00 ' + currency;
        }
        num = parseFloat(num);
        var p = num.toFixed(2).split(".");
        return p[0].split("").reverse().reduce(function (acc, num, i, orig) {
            orig = "";
            console.log(orig);
            return num + (num != "-" && i && !(i % 3) ? "," : "") + acc;
        }, "") + "." + p[1] + ' ' + currency;
    },

    /**
     * Checks if the customer setting is enabled for the requested user and returns the setting
     * @param authUser - the user object
     * @param settingName - customer setting title
     * 
     * @return the setting value
     */
    isCustomerSettingEnabled(authUser, settingName) {
        if (authUser.customer_instance && authUser.customer_instance.customer_settings && authUser.customer_instance.customer_settings.length > 0) {
            const setting = authUser.customer_instance.customer_settings.find(cs => cs.setting.name == settingName);
            if (setting) {

                let value = setting.value;

                if (setting.type == 'number') {
                    value = parseInt(value);
                }

                return value;
            }
        }

        return false;
    },

    /**
     * Calculates the application fee for the price given
     * @param applicationFeePercentage - percentage of the application
     * @param price - the price of the product
     * 
     * @return application fee in cents
     */
    calculateApplicationFee(applicationFeePercentage, price) {
        const appFeePercentage = parseFloat(applicationFeePercentage);
        const appFee = (parseFloat(price) * (appFeePercentage / 100)).toFixed(2);

        return parseInt(appFee.split(".")[0] + appFee.split(".")[1]);
    },

    /**
     * Returns Language Name
     * @param isoName - ISO Name of the language (Eg: en, se);
     * 
     * @return string - Language Name
     */
    getLangNameByISOName(isoName) {

        isoName = isoName.toLowerCase();
        const result = Constants.isoLangs.filter(function (lang) {
            return isoName == lang.code;
        });

        if (result && result.length > 0) {
            return result[0];
        }

    },

    /**
     * Gets the user language for the logged in user
     * @param settings - the general, customer and user settings for the user
     * @param availableLangs - available languages in the application
     * 
     * @return string - the user language
     */
    determineUserLang(settings, availableLangs) {
        const browserLang = window.navigator.language.split("-")[0];
        if (browserLang != "en" && availableLangs.includes(browserLang)) {
            return browserLang;
        } else {
            return settings.moodleSession.lang ? settings.moodleSession.lang : settings.instanceSettings.lang;
        }
    },

    /**
     * Verfies if a passed string is a valid URL
     * @param {*} string 
     * @returns 
     */
    isValidHttpUrl(string) {
        let url;

        try {
            url = new URL(string);
        } catch (_) {
            return false;
        }

        return url.protocol === "http:" || url.protocol === "https:";
    },

    epochToJsDate(ts) {
        // ts = epoch timestamp
        // returns date obj
        let date = new Date(ts * 1000);
        return date;

    },

    jsDateToEpoch(d) {
        // d = javascript date obj
        // returns epoch timestamp
        return (d.getTime() - d.getMilliseconds()) / 1000;
    }

}
